var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDividerVertical = function SvgDividerVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 326,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0v325.19",
    stroke: "#CCC"
  })));
};
export default SvgDividerVertical;